/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `12` - 12
 * `18` - 18
 * `24` - 24
 * `30` - 30
 */
export type VideoFpsEnum = (typeof VideoFpsEnum)[keyof typeof VideoFpsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoFpsEnum = {
  NUMBER_12: 12,
  NUMBER_18: 18,
  NUMBER_24: 24,
  NUMBER_30: 30,
} as const;
